import { sourceColor, sourceLabel } from '../../lib/leadSource'

export function SourceBadge({ source, className = '' }: { source?: string | null; className?: string }) {
  if (!source?.trim()) return null
  return (
    <span className={`badge text-white ${className}`}
      style={{ backgroundColor: sourceColor(source) }}>
      {sourceLabel(source)}
    </span>
  )
}
